import { render, staticRenderFns } from "./DataPesertaSertifikasiDetailNew.vue?vue&type=template&id=1e511041&scoped=true&"
import script from "./DataPesertaSertifikasiDetailNew.vue?vue&type=script&lang=js&"
export * from "./DataPesertaSertifikasiDetailNew.vue?vue&type=script&lang=js&"
import style0 from "./DataPesertaSertifikasiDetailNew.vue?vue&type=style&index=0&id=1e511041&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e511041",
  null
  
)

export default component.exports